import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/morewings/react-calendar-toolkit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Datepicker } from 'lib';
import Day from './Day';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p><inlineCode parentName="p">{`Day`}</inlineCode>{` component displays specific date with `}<a parentName="p" {...{
        "href": "/#calendar-views-and-precision"
      }}><strong parentName="a">{`day precision`}</strong></a>{`. `}<inlineCode parentName="p">{`onDateSet`}</inlineCode>{` callback prop allows to set provided Date object as selected in `}<inlineCode parentName="p">{`Datepicker`}</inlineCode>{`. Replace it with custom component.`}</p>
    <Playground __position={0} __code={'() => {\n  const style = {\n    boxSizing: \'border-box\',\n    flex: \'1 1 calc(100%/7 - 4px)\',\n    color: \'black\',\n    textAlign: \'center\',\n    padding: \'0\',\n    fontSize: \'12px\',\n    lineHeight: \'30px\',\n    border: \'2px dashed pink\',\n    margin: \'2px\',\n  }\n  const CustomComponent = ({\n    onDateSet,\n    date,\n    isSameMonth,\n    isToday,\n    isSelected,\n    isDisabled,\n    isHighlighted,\n    isWeekend,\n    name,\n  }) => {\n    const handleClick = () => {\n      console.log(\'date set\', date)\n      onDateSet(date)\n    }\n    return (\n      <div onClick={handleClick} style={style}>\n        {name.numeric}\n      </div>\n    )\n  }\n  return (\n    <Datepicker\n      onDateSet={date => {\n        console.log(\'date set\', date)\n      }}\n      minPrecision=\"day\"\n      renderDayAs={CustomComponent}\n      title=\"Demo datepicker\"\n    />\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Datepicker,
      Day,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const style = {
          boxSizing: 'border-box',
          flex: '1 1 calc(100%/7 - 4px)',
          color: 'black',
          textAlign: 'center',
          padding: '0',
          fontSize: '12px',
          lineHeight: '30px',
          border: '2px dashed pink',
          margin: '2px'
        };

        const CustomComponent = ({
          onDateSet,
          date,
          isSameMonth,
          isToday,
          isSelected,
          isDisabled,
          isHighlighted,
          isWeekend,
          name
        }) => {
          const handleClick = () => {
            console.log('date set', date);
            onDateSet(date);
          };

          return <div onClick={handleClick} style={style}>
          {name.numeric}
        </div>;
        };

        return <Datepicker onDateSet={date => {
          console.log('date set', date);
        }} minPrecision="day" renderDayAs={CustomComponent} title="Demo datepicker" mdxType="Datepicker" />;
      }}
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Day} mdxType="Props" />
    <h2 {...{
      "id": "wrap-with-custom-css-class"
    }}>{`Wrap with custom CSS class`}</h2>
    <p>{`You can override CSS classname of Day Calendar element, see `}<inlineCode parentName="p">{`dayCalendarClassName`}</inlineCode>{` prop.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Datepicker
  onDateSet={date => {console.log('date set', date);}}
  minPrecision="day"
  dayCalendarClassName="your-custom-className"
  title="Demo datepicker" />
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      